"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    skipFieldAssetDataIfThisMD5Hash: zod_1.z.string().optional(),
});
exports.path = '/user-app-startup';
//# sourceMappingURL=index.js.map